module.exports = __webpack_public_path__ + "img/20200508144829TIM截图20200508144710.6393b7ec.png";